import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectAccountId, selectApi, serializeError } from '@socialive/common';
import { upsertAccountChannel } from '../slice';

export default createAsyncThunk(
  'spaces/updateSpace',
  async ({ id, data, trigger }, { dispatch, getState }) => {
    const api = selectApi(getState());
    const accountId = selectAccountId(getState());

    const { user, ...space } = await api(`/v1/accounts/${accountId}/spaces/${id}`, {
      method: 'PATCH',
      data,
    });

    await dispatch(upsertAccountChannel({ token: space.token, data: { ...space, creatorName: user.name }, trigger }));

    return { space: { ...space, creatorName: user.name } };
  },
  { serializeError }
);
